import {lazy} from 'preact-iso';

import MojitoApplications from 'mojito/applications';

import {resolveBackground} from '#core/utils/color-utils.js';
import {ensureHierarchy} from '#core/utils/config-utils.js';

import {AbstractVisualFeature, allVisuals} from '../visual-feature.js';

import SCHEMA from './custom-page.schema.yaml';
import PALETTE_SCHEMA from './custom-page.palette-schema.yaml';

const CustomPage = lazy(() => import('./custom-page.jsx'));
const {RouterStore} = MojitoApplications.Common;

class CustomPageFeature extends AbstractVisualFeature {
    get name() {
        return 'Custom page';
    }

    get configSchema() {
        return SCHEMA;
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    updateViewsConfig(viewsConfig) {
        const RoutingView = ensureHierarchy(viewsConfig, 'RoutingView');
        const routeResolver = RouterStore.routeResolverFactory.getRouteResolver();
        const paths = Array.isArray(this.config.path) ? this.config.path : [this.config.path];

        RoutingView.customRoutes = RoutingView.customRoutes || [];
        RoutingView.customRoutes.push({
            path: paths.map(path => routeResolver.enrichWithRoot(path)),
            component: () => <CustomPage customHtml={this.config.customHtml} scriptUrl={this.config.scriptUrl} />,
        });

        super.updateViewsConfig(viewsConfig);
    }

    getSerializableVisualConfig(PALETTE) {
        return {
            CustomPage: {
                primaryContentContainer: {
                    style: {
                        ...resolveBackground(PALETTE.MAIN_CONTAINER_BG),
                    },
                },
            },
        };
    }
}

export const customPageFeature = new CustomPageFeature(allVisuals);
